import { render, staticRenderFns } from "./HandbookEntity.vue?vue&type=template&id=16be966e&scoped=true&"
import script from "./HandbookEntity.vue?vue&type=script&lang=js&"
export * from "./HandbookEntity.vue?vue&type=script&lang=js&"
import style0 from "./HandbookEntity.vue?vue&type=style&index=0&id=16be966e&lang=scss&scoped=true&"
import style1 from "./HandbookEntity.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be966e",
  null
  
)

export default component.exports